import { render, staticRenderFns } from "./PricingUnavailableForm.vue?vue&type=template&id=2d2c1135&scoped=true&"
import script from "./PricingUnavailableForm.vue?vue&type=script&lang=js&"
export * from "./PricingUnavailableForm.vue?vue&type=script&lang=js&"
import style0 from "./PricingUnavailableForm.vue?vue&type=style&index=0&id=2d2c1135&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d2c1135",
  null
  
)

export default component.exports